import dayjs from "dayjs";

export const getMonths = (yearFrom: number, monthFrom: number, yearTo: number, monthTo: number) => {
  const months: string[] = [];
  
  // Handle single year case
  if (yearFrom === yearTo) {
    for (let month = monthFrom; month <= monthTo; month++) {
      months.push(`${yearFrom}-${String(month).padStart(2, '0')}`);
    }
    return months;
  }

  // Handle multi-year case
  for (let year = yearFrom; year <= yearTo; year++) {
    const startMonth = year === yearFrom ? monthFrom : 1;
    const endMonth = year === yearTo ? monthTo : 12;
    
    for (let month = startMonth; month <= endMonth; month++) {
      months.push(`${year}-${String(month).padStart(2, '0')}`);
    }
  }
  
  return months;
};

export const getAllDatesBetween = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
  const dates: string[] = [];
  let currentDate = start;

  while (currentDate.isSameOrBefore(end)) {
      dates.push(currentDate.format('YYYY-MM-DD'));
      currentDate = currentDate.add(1, 'day');
  }

  return dates;
};
